import { FC, useEffect, useRef } from "react"
import { Image, Mask } from "antd-mobile";
import styles from "./index.module.less";
import { game_share_toast } from "~src/assets/images/answerGame";

interface MaskShareProps {
  visible: boolean;
  tips: string| JSX.Element;
  onMaskClick?: () => void
}
const MaskShare: FC<MaskShareProps> = ({visible, tips,onMaskClick }) => {
  const timer = useRef<NodeJS.Timeout>()
  useEffect(() => {
    if (visible) {
      timer.current = setTimeout(() => {
        onMaskClick&&onMaskClick()
      }, 3000)
    }
    return () => {
      timer.current && clearTimeout(timer.current)
    }
  }, [onMaskClick, visible])
  return <Mask className={styles.mask} visible={visible} onMaskClick={onMaskClick} opacity={.4} >
    <div className={styles.share}>
      <div className={styles["share-boby"]}>
        <Image className={styles.game_share_toast} src={game_share_toast}></Image>
        <div>{tips}</div>
      </div>
    </div>
  </Mask>
}

export default MaskShare